import { takeEvery } from 'redux-saga/effects';

import {
  ChangeExtractRefreshSchedule, ChangeRemoteExtractRefresh, ChangeRemoteExtractRefreshExpectedDuration,
  CreateExtractRefresh, CreateExtracts, CreateRemoteExtractRefresh,
  DeleteExtractRefresh, DeleteRemoteExtractRefresh,
  ResumeExtractRefresh, RunExtractRefresh,
RunExtractRefreshNow,
  SetExtractRefreshPriority} from '../../../actions/AppActionTypes';
import { handleChangeExtractRefreshScheduleAction } from './ChangeExtractRefreshScheduleSaga';
import { handleChangeRemoteExtractRefreshExpectedDurationAction } from './ChangeRemoteExtractRefreshExpectedDurationSaga';
import { handleChangeRemoteExtractRefreshAction } from './ChangeRemoteExtractRefreshSaga';
import { handleCreateExtractRefreshAction } from './CreateExtractRefreshSaga';
import { handleCreateRemoteExtractRefreshAction } from './CreateRemoteExtractRefreshSaga';
import { handleDeleteExtractRefreshAction } from './DeleteExtractRefreshSaga';
import { handleDeleteRemoteExtractRefreshAction } from './DeleteRemoteExtractRefreshSaga';
import { handleResumeExtractRefreshAction } from './ResumeExtractRefreshSaga';
import { handleCreateExtractsAction } from './RunCreateExtractsSaga';
import { handleRunExtractRefreshNowAction } from './RunExtractRefreshNowSaga';
import { handleRunExtractRefreshAction } from './RunExtractRefreshSaga';
import { handleSetExtractRefreshPriorityAction } from './SetExtractRefreshPrioritySaga';

export function* rootExtractRefreshSaga() {
  yield takeEvery(CreateExtractRefresh, handleCreateExtractRefreshAction);
  yield takeEvery(CreateExtracts, handleCreateExtractsAction);
  yield takeEvery(RunExtractRefresh, handleRunExtractRefreshAction);
  yield takeEvery(RunExtractRefreshNow, handleRunExtractRefreshNowAction);
  yield takeEvery(ResumeExtractRefresh, handleResumeExtractRefreshAction);
  yield takeEvery(ChangeExtractRefreshSchedule, handleChangeExtractRefreshScheduleAction);
  yield takeEvery(SetExtractRefreshPriority, handleSetExtractRefreshPriorityAction);
  yield takeEvery(DeleteExtractRefresh, handleDeleteExtractRefreshAction);
  yield takeEvery(CreateRemoteExtractRefresh, handleCreateRemoteExtractRefreshAction);
  yield takeEvery(DeleteRemoteExtractRefresh, handleDeleteRemoteExtractRefreshAction);
  yield takeEvery(ChangeRemoteExtractRefresh, handleChangeRemoteExtractRefreshAction);
  yield takeEvery(ChangeRemoteExtractRefreshExpectedDuration, handleChangeRemoteExtractRefreshExpectedDurationAction);
}
